import { defineComponent as _defineComponent } from 'vue';
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, resolveDirective as _resolveDirective, withDirectives as _withDirectives, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-224f4c98"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "auth-form" };
const _hoisted_2 = { class: "auth-form__logo" };
const _hoisted_3 = ["src"];
const _hoisted_4 = ["src"];
const _hoisted_5 = {
    class: "auth-form__welcome-msg",
    key: "welcome"
};
const _hoisted_6 = ["onSubmit"];
const _hoisted_7 = { key: "login-fields" };
const _hoisted_8 = { class: "auth-form__group" };
const _hoisted_9 = { for: "user" };
const _hoisted_10 = ["placeholder"];
const _hoisted_11 = { class: "auth-form__group" };
const _hoisted_12 = { for: "password" };
const _hoisted_13 = ["placeholder"];
const _hoisted_14 = {
    class: "auth-form__group",
    key: "email-field"
};
const _hoisted_15 = { for: "email" };
const _hoisted_16 = ["placeholder"];
const _hoisted_17 = { class: "auth-form__group" };
import { useAnalyticsAuth } from '@/features/Login360/analytics/composables';
import i18n from '@/i18n';
import { useMixpanelConfig } from '@/utilities/mixpanel';
import { computed, onMounted, reactive } from 'vue';
import * as z from 'zod';
export default /*#__PURE__*/ _defineComponent({
    __name: 'LoginCRM360',
    emits: ['login-success'],
    setup(__props, { emit }) {
        const { t } = i18n.global;
        const { loading, isValidUser, validateUser, createUser } = useAnalyticsAuth();
        const formData = reactive({ user: '', password: '', email: '' });
        const formErrors = reactive({ user: '', password: '', email: '' });
        const showEmailForm = computed(() => isValidUser.value);
        const disableSubmit = computed(() => {
            if (!isValidUser.value) {
                return formData.user.trim() === '' || formData.password.trim() === '';
            }
            return formData.email.trim() === '';
        });
        async function submitForm() {
            const { user, password, email } = formData;
            const dataToValidate = isValidUser.value ? { email } : { user, password };
            const schemaToUse = isValidUser.value
                ? z.object({
                    email: z.string().email({ message: t('login360.analytics.validation.email-invalid') }),
                })
                : z.object({
                    user: z
                        .string()
                        .min(2, t('login360.analytics.validation.user-min'))
                        .max(100, t('login360.analytics.validation.user-max')),
                    password: z
                        .string()
                        .min(6, t('login360.analytics.validation.password-min'))
                        .max(100, t('login360.analytics.validation.password-max')),
                });
            const { success, error } = schemaToUse.safeParse(dataToValidate);
            formErrors.user = '';
            formErrors.password = '';
            formErrors.email = '';
            if (!success) {
                error.issues.forEach(({ path, message }) => {
                    if (path[0] === 'user')
                        formErrors.user = message || '';
                    if (path[0] === 'password')
                        formErrors.password = message || '';
                    if (path[0] === 'email')
                        formErrors.email = message || '';
                });
                return;
            }
            if (!isValidUser.value) {
                await validateUser(user, password);
            }
            else {
                const userCreated = await createUser(email);
                if (userCreated)
                    emit('login-success');
            }
        }
        onMounted(() => {
            useMixpanelConfig('view_migration360_analytics');
        });
        return (_ctx, _cache) => {
            const _component_el_button = _resolveComponent("el-button");
            const _directive_tooltip = _resolveDirective("tooltip");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("header", _hoisted_2, [
                    _createElementVNode("img", {
                        src: require('@/assets/svgs/login/logo-oto.svg'),
                        alt: "Oto",
                        class: _normalizeClass(['auth-form__logo-oto', { 'auth-form__logo-oto--large': showEmailForm.value }])
                    }, null, 10, _hoisted_3),
                    _createVNode(_Transition, {
                        name: "slide-right",
                        mode: "out-in"
                    }, {
                        default: _withCtx(() => [
                            (!showEmailForm.value)
                                ? (_openBlock(), _createElementBlock("img", {
                                    src: require('@/assets/svgs/login/logo-crm.svg'),
                                    alt: "Logo 360",
                                    key: "logo",
                                    class: "auth-form__logo-crm"
                                }, null, 8, _hoisted_4))
                                : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.$t('login360.analytics.welcome-message')), 1))
                        ]),
                        _: 1
                    })
                ]),
                _createElementVNode("form", {
                    class: "auth-form__form",
                    onSubmit: _withModifiers(submitForm, ["prevent"])
                }, [
                    _createVNode(_Transition, {
                        name: "slide-right",
                        mode: "out-in"
                    }, {
                        default: _withCtx(() => [
                            (!showEmailForm.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                    _createElementVNode("div", _hoisted_8, [
                                        _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t('login360.analytics.username')), 1),
                                        _withDirectives(_createElementVNode("input", {
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((formData.user) = $event)),
                                            type: "text",
                                            id: "user",
                                            placeholder: _ctx.$t('login360.analytics.username-placeholder'),
                                            required: ""
                                        }, null, 8, _hoisted_10), [
                                            [_vModelText, formData.user],
                                            [
                                                _directive_tooltip,
                                                {
                                                    theme: 'error',
                                                    autoHide: false,
                                                    distance: 8,
                                                    content: formErrors.user,
                                                    shown: formErrors.user !== '',
                                                },
                                                void 0,
                                                { left: true }
                                            ]
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_11, [
                                        _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t('login360.analytics.password')), 1),
                                        _withDirectives(_createElementVNode("input", {
                                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((formData.password) = $event)),
                                            type: "password",
                                            id: "password",
                                            placeholder: _ctx.$t('login360.analytics.password-placeholder'),
                                            required: ""
                                        }, null, 8, _hoisted_13), [
                                            [_vModelText, formData.password],
                                            [
                                                _directive_tooltip,
                                                {
                                                    theme: 'error',
                                                    autoHide: false,
                                                    distance: 8,
                                                    content: formErrors.password,
                                                    shown: formErrors.password !== '',
                                                },
                                                void 0,
                                                { left: true }
                                            ]
                                        ])
                                    ])
                                ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                    _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$t('login360.analytics.email-label')), 1),
                                    _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((formData.email) = $event)),
                                        type: "email",
                                        id: "email",
                                        placeholder: _ctx.$t('login360.analytics.email-placeholder'),
                                        required: ""
                                    }, null, 8, _hoisted_16), [
                                        [_vModelText, formData.email],
                                        [
                                            _directive_tooltip,
                                            {
                                                theme: 'error',
                                                autoHide: false,
                                                distance: 8,
                                                content: formErrors.email,
                                                shown: formErrors.email !== '',
                                            },
                                            void 0,
                                            { left: true }
                                        ]
                                    ])
                                ]))
                        ]),
                        _: 1
                    }),
                    _createElementVNode("div", _hoisted_17, [
                        _createVNode(_component_el_button, {
                            "native-type": "submit",
                            loading: _unref(loading),
                            disabled: disableSubmit.value
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('login360.analytics.next-button')), 1)
                            ]),
                            _: 1
                        }, 8, ["loading", "disabled"])
                    ])
                ], 40, _hoisted_6)
            ]));
        };
    }
});
